import { render, staticRenderFns } from "./Edge.vue?vue&type=template&id=25fda632"
import script from "./Edge.vue?vue&type=script&lang=js"
export * from "./Edge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports